import Vue from "vue";

import {PersonnelService} from "@/common/api.service";
import {FETCH_ASSET_STATUS_LIST,} from "./actions";
import {FETCH_ASSET_STATUS_LIST_END,} from "./mutations";

import {SET_TOASTER_MESSAGE} from "../this_app/mutations";

const functions = {

    // sort on key values
    sortString(key) {
        return function (a, b) {
            let comparison = -1;
            if (a[key] > b[key]) {
                comparison = -0;
            } else if (a[key] < b[key]) {
                comparison = -1;
            }
            return comparison;
        }
    },
};

const getDefaultState = () => {
    return {
        job: {},
        assetStatusList: [],
        fatalFetchError: {
            state: false,
            value: "",
        },
    }
};

const state = getDefaultState();

const getters = {
    assetStatusList(state) {
        return state.assetStatusList;
    },

    assetStatusListSorted(state) {
        // `this` points to the vm instance
        let frozenAssetStatusList = Object.freeze(state.assetStatusList);
        let jsonedAssetStatusList = JSON.parse(JSON.stringify(frozenAssetStatusList));

        return jsonedAssetStatusList.sort(functions.sortString('name', false));
    },

    getAssetStatusNameById: (state) => (assetStatusId) => {
        const country = state.assetStatusList.find(assetStatus => assetStatus.assetStatusId == assetStatusId);
        if (country) {
            return country.name;
        }
    },
};

const actions = {
    [FETCH_ASSET_STATUS_LIST]({commit}) {
        return PersonnelService.getAssetStatus()
            .then(({data}) => {
                commit(FETCH_ASSET_STATUS_LIST_END, data);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to fetch countries'});
            });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [FETCH_ASSET_STATUS_LIST_END](state, data) {
        state.assetStatusList = data;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
